import Vue from 'vue'
import VueFusionCharts from 'vue-fusioncharts'
import FusionCharts from 'fusioncharts'
import Charts from 'fusioncharts/fusioncharts.charts'
import Widgets from 'fusioncharts/fusioncharts.widgets'
import RegisterTheme from './fusioncharts-micad'
import candy from 'fusioncharts/themes/es/fusioncharts.theme.candy'
import carbon from 'fusioncharts/themes/es/fusioncharts.theme.carbon'
import fint from 'fusioncharts/themes/es/fusioncharts.theme.fint'
import fusion from 'fusioncharts/themes/es/fusioncharts.theme.fusion'
import gammel from 'fusioncharts/themes/es/fusioncharts.theme.gammel'
import ocean from 'fusioncharts/themes/es/fusioncharts.theme.ocean'
import umber from 'fusioncharts/themes/es/fusioncharts.theme.umber'
import zune from 'fusioncharts/themes/es/fusioncharts.theme.zune'

FusionCharts.addDep(candy, carbon, fint, fusion, gammel, ocean, umber, zune)

RegisterTheme()
// register VueFusionCharts component
Vue.use(VueFusionCharts, FusionCharts, Charts, Widgets)